import './BakingLists.scss';
import Component from './BakingLists.js';
export default Component;
